import React from 'react';
import './ProfilePicture.css';

function ProfilePicture() {
    return (
        <div className="profile-picture">
            <img src={`${process.env.PUBLIC_URL}/Img/ProfileImg/ProfileImg.png`} alt="Profile" />
        </div>
    );
}

export default ProfilePicture;
